import React from 'react';
import PropTypes from 'prop-types';
import AppLayout from '../../layout/app.layout';
import ChannelAssignment from '../../components/content/channel-assignment.component';

const ChannelAssignmentView = ({ hasContentOwnerAccess }) => {
  const pageTitle = hasContentOwnerAccess
    ? 'View Schedule'
    : 'Schedule Videos / Manual Assignment';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ChannelAssignment />
    </AppLayout>
  );
};

ChannelAssignmentView.propTypes = {
  hasContentOwnerAccess: PropTypes.bool.isRequired,
};

export default ChannelAssignmentView;
